export default {
  meta: {
    title: '决策报告'
  }
};
